import { FC } from 'react'

import { TECHNOLOGY_TYPE_LABELS } from '@core/modules/digital-footprint/technologies/constants'
import { DetailsGrid } from '@ui/drawer/common/DetailsGrid'
import { InfoItem } from '@ui/drawer/common/infoItem'

import { TechnologyInfoProps } from './technologyInfo.types'

const TechnologyInfo: FC<TechnologyInfoProps> = ({ technology }) => {
    const { type, version } = technology
    const sourceLabel = type ? (TECHNOLOGY_TYPE_LABELS[type] ?? type) : '—'

    return (
        <DetailsGrid dataTestId="technology-details-grid">
            <InfoItem title="Source" dataTestId="technology-source">
                {sourceLabel}
            </InfoItem>
            <InfoItem title="Version" dataTestId="technology-version">
                {version || '—'}
            </InfoItem>
        </DetailsGrid>
    )
}

export default TechnologyInfo
